import httpService from './httpService';

class CountryService {
	endpoint: string = process.env.REACT_APP_COUNTRY_API as string;

	getCitiesInState(country: string, state: string) {
		return httpService.post(this.endpoint + '/state/cities', {
			country,
			state,
		});
	}

	getCountries() {
		return httpService.get(this.endpoint + '/iso');
	}

	getStatesInCountry(country: string) {
		return httpService.post(this.endpoint + '/states', { country });
	}
}

const countryService = new CountryService();
export default countryService;
